import React, { useMemo } from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { desktop, mediumDesktop, tablet } from 'helpers/utils/screensizes';
import Tile, { Props as TileProps } from './tile';
import Wrapper from '../../../HOC/wrapper';
import Slider from '../../atoms/slider';

export interface Props {
  tiles: Array<TileProps['tile']>;
}

const CategorySlider: React.FC<Props> = ({ tiles = [] }) => {
  const { isTouchDevice } = useTouchDevice();

  const [isDesktopSize] = useMediaQuery(mediumDesktop);

  const showArrows = useMemo(
    () => !isTouchDevice && !((isDesktopSize && tiles.length <= 4) || (!isDesktopSize && tiles.length <= 2)),
    [isDesktopSize, isTouchDevice, tiles.length],
  );

  return (
    <Wrapper background="white" clearDefaultStyles className="w-full px-16 pb-24 md:px-0">
      <div className="mx-auto max-w-screen-2xl">
        <h2 className="mb-16 text-28 font-medium leading-[32px] text-primary md:text-64 md:leading-[68px]">
          {'Shop by category'}
        </h2>
        <Slider
          containerClassName=""
          slidesPerView={1.2}
          dots={false}
          spaceBetween={8}
          arrows={showArrows}
          innerArrows
          allowTouchMove={!showArrows}
          slidesOffsetAfter={8}
          breakpoints={{
            [tablet]: {
              spaceBetween: 16,
              slidesPerView: 1.7,
              slidesOffsetAfter: 0,
            },
            [desktop]: {
              spaceBetween: 16,
              slidesPerView: 5,
              slidesOffsetAfter: 0,
            },
            [mediumDesktop]: {
              spaceBetween: 16,
              slidesPerView: 5,
            },
          }}
        >
          {tiles.map((tile, index) => (
            <Tile key={index} tile={tile} />
          ))}
        </Slider>
      </div>
    </Wrapper>
  );
};

export default CategorySlider;
